import React from "react";
import { MainLayout } from "../../../layout/MainLayout";
import { Grid } from "../../../UI/Grid";
import useAuth from "../../login/AuthContext";
import { ProfilePhotoJobCard } from "./ProfilePhotoJobCard";

export const PROFILE_PHOTO_JOBS = "/super-admin/profile-photos";

export const ProfilePhotoJobs: React.FunctionComponent = () => {
  const { isWriteAccess } = useAuth();

  return (
    <MainLayout title="Profile Photos">
      {isWriteAccess() && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <ProfilePhotoJobCard
              job="backfill"
              title="Backfill"
              description="Copies each user's current profile picture to <uid>/photos/ and records it as their Profile photo. Users who already have one are skipped, so it is safe to run again. Nothing is deleted."
              buttonLabel="Run backfill"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProfilePhotoJobCard
              job="cleanup"
              title="Cleanup"
              description="Deletes the old root uid_* pictures of every user who has a Profile photo. Run it only once the API reads Photos, and after a final backfill."
              buttonLabel="Run cleanup"
              confirmation="This permanently deletes legacy profile pictures from S3. Has the API release that reads Photos shipped, and has the backfill been re-run since?"
            />
          </Grid>
        </Grid>
      )}
    </MainLayout>
  );
};
